var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "password-requirements",
      class: { "all-requirements-met": _vm.allRequirementsMet },
    },
    [
      _c(
        "h4",
        {
          staticClass: "requirements-title",
          class: { "title-fade": _vm.allRequirementsMet },
        },
        [_vm._v("Password Requirements")]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "requirements-list" },
        [
          _vm._l(_vm.displayRequirements, function (requirement) {
            return _c(
              "li",
              {
                key: requirement.name,
                staticClass: "requirement-item",
                class: {
                  "requirement-met": requirement.met,
                  "requirement-warning":
                    requirement.warning && !requirement.met,
                  "requirement-fade": _vm.shouldFadeRequirement(requirement),
                },
              },
              [
                _c("span", { staticClass: "requirement-icon" }, [
                  _c("i", { class: _vm.getRequirementIcon(requirement) }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "requirement-text" }, [
                  _vm._v(_vm._s(requirement.text)),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.passwordsMatch || !_vm.allRequirementsMet
            ? _c(
                "li",
                {
                  staticClass: "requirement-item",
                  class: {
                    "requirement-met": _vm.passwordsMatch,
                    "requirement-fade": _vm.passwordsMatch,
                  },
                },
                [
                  _c("span", { staticClass: "requirement-icon" }, [
                    _c("i", {
                      class: _vm.passwordsMatch
                        ? "fas fa-check"
                        : "fas fa-times",
                    }),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "requirement-text" }, [
                    _vm._v("Passwords must match"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isWeakPasswordsAllowed &&
          (_vm.strengthLevel < 3 || !_vm.allRequirementsMet)
            ? _c(
                "li",
                {
                  staticClass: "requirement-item",
                  class: {
                    "requirement-met": _vm.strengthLevel >= 3,
                    "requirement-fade": _vm.strengthLevel >= 3,
                  },
                },
                [
                  _c("span", { staticClass: "requirement-icon" }, [
                    _c("i", {
                      class:
                        _vm.strengthLevel >= 3
                          ? "fas fa-check"
                          : "fas fa-times",
                    }),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "requirement-text" }, [
                    _vm._v('Password strength must be at least "Strong"'),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }